/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumKeywordProcess {
	Scraper		= 'scraper',
	Live		= 'live'
}
